import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { FollowUsTitle } from "../../../../../Constants/Constants";
import { LI, UL } from "../../../../../AbstractElements";
import { FollowUsData } from "../../../../../Data/Miscellaneous/Blog";
import { Link } from "react-router-dom";

const FollowUs = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={FollowUsTitle} headClass="pb-0 border-0" />
        <CardBody>
          <UL className="blog-follow simple-list flex-row">
            {FollowUsData.map((item, index) => (
              <LI key={index}>
                <Link to={item.href} target="_blank">
                  <i className={`fa ${item.icon}`} />
                </Link>
              </LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default FollowUs;
